var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"sort-by":"year","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"small":"","rounded":"","depressed":""},on:{"click":function($event){return _vm.download(item)}}},[_vm._v("Download")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }